import { type MoneyMapWithRulesAndAccounts } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';
import { captureException } from '../../logger/Logger';

const fetchActiveMoneyMap = requestBuilder.query<MoneyMapWithRulesAndAccounts>({
    endpoint: `/api/money-map/active`,
    queryKey: `getActiveMoneyMap`,
});

const useGetActiveMoneyMap = (isEnabled: boolean = true) => {
    const { data, isLoading, refetch, isRefetching, isError, error } =
        fetchActiveMoneyMap(
            {},
            {
                staleTime: 1000 * 60, // 1 minute, to prevent refetching constantly when not necessary
                enabled: isEnabled,
            },
        );

    if (isError && error != null) {
        captureException(error);
    }

    return {
        moneyMap: data,
        isLoadingMoneyMap: isLoading || isRefetching,
        refetchMoneyMap: refetch,
        hasMoneyMapError: isError,
    };
};

export default useGetActiveMoneyMap;
